











import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
// import { State, Action } from 'vuex-class'

import JobEmploymentPositionHelperComponents1MainPage from './service-for-job-employment-position-helper-components/job-employment-position-helper-components-1-main-page.vue'
import App4PageNotFound from '../../../html-components-type-1-basic/basic-type-1-app/app-4-page-not-found.vue'

// const namespace = 'digitalCurrency'

@Component({
  components: {
    JobEmploymentPositionHelperComponents1MainPage,
    App4PageNotFound
  }
})
class JobEmploymentPosition1 extends Vue {

  // @Action('getDigitalCurrencyTransactionById', { namespace }) getDigitalCurrencyTransactionById?: any

  jobEmploymentPositionId: string = ''

  show404Message: boolean = false

  @Watch('$route.params.jobEmploymentPositionId') async updateRouteValue () {
    await this.initializeProductResource()
  }

  async mounted () {
    await this.initializeProductResource()
  }

  async initializeProductResource () {
    this.show404Message = false
    const jobEmploymentPositionId = this.$router.currentRoute.params.jobEmploymentPositionId

    console.log('jobEmploymentPositionId: ', jobEmploymentPositionId)
    // const digitalCurrencyTransaction = null // await this.getDigitalCurrencyTransactionById(transactionId)

    // if (!digitalCurrencyTransaction || !digitalCurrencyTransaction.transactionId) {
    //   this.show404Message = true
    //   return
    // }

    // this.transactionId = digitalCurrencyTransaction.transactionId
  }
}

export default JobEmploymentPosition1


